// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Case Usage Example:
h1 { @include font-roboto(400); }
**/
h1 {
  font-size: 2rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h1 {
    font-size: 1.5rem;
  }
}

h2 {
  font-size: 1.8rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h2 {
    font-size: 1.2rem;
  }
}

.spinner-wrap {
  display: flex;
  align-items: center;
}
.spinner-wrap .spinner-text {
  color: #aa004f;
}
.spinner-wrap .spinner {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #aa004f;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 2s linear infinite;
}
.spinner-wrap .spinner.sm {
  border: 7px solid #f3f3f3;
  border-top: 7px solid #aa004f;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-left: 15px;
}
.spinner-wrap .spinner.md {
  border: 10px solid #f3f3f3;
  border-top: 10px solid #aa004f;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-left: 15px;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/css/fonts.scss","webpack://./src/widgets/Spinner/styles.scss","webpack://./src/css/colors.scss"],"names":[],"mappings":"AAMA;;;EAAA;AASA;EACE,eAAA;EACA,aAAA;ACTF;ADUE;EAHF;IAII,iBAAA;ECPF;AACF;;ADSA;EACE,iBAAA;EACA,aAAA;ACNF;ADOE;EAHF;IAII,iBAAA;ECJF;AACF;;AAnBA;EACE,aAAA;EACA,mBAAA;AAsBF;AArBE;EACE,cCHK;AD0BT;AArBE;EACE,0BAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;AAuBJ;AArBI;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAuBN;AArBI;EACE,0BAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAuBN;AAnBE;EACE;IACE,uBAAA;EAqBJ;EAnBE;IACE,yBAAA;EAqBJ;AACF","sourcesContent":["@import \"./breakpoints\";\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap');\n@mixin font-roboto($weight) {\n  font-family: 'Roboto', sans-serif;\n  font-weight: $weight;\n}\n/**\nCase Usage Example:\nh1 { @include font-roboto(400); }\n**/\n\n$font-sm:1.1rem;\n$font-md:1.2rem;\n$font-lg:1.3rem;\n\nh1 {\n  font-size: 2rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.5rem;\n  }\n}\nh2 {\n  font-size: 1.8rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.2rem;\n  }\n}\n","@import \"../../css/breakpoints\";\n@import \"../../css/fonts\";\n@import \"../../css/colors.scss\";\n\n.spinner-wrap {\n  display: flex;\n  align-items: center;\n  .spinner-text {\n    color: $color6;\n  }\n  .spinner {\n    border: 12px solid #f3f3f3;\n    border-top: 12px solid $color6;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    animation: spin 2s linear infinite;\n\n    &.sm {\n      border: 7px solid #f3f3f3;\n      border-top: 7px solid $color6;\n      border-radius: 50%;\n      width: 40px;\n      height: 40px;\n      margin-left: 15px;\n    }\n    &.md {\n      border: 10px solid #f3f3f3;\n      border-top: 10px solid $color6;\n      border-radius: 50%;\n      width: 40px;\n      height: 40px;\n      margin-left: 15px;\n    }\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n}\n@media (max-width: 992px) {\n}\n","$color1: #e34634;\n$color2: #d02050;\n$color3: #46b1ff;\n$color4: #f5eee7;\n$color5: #baad9e;\n$color6: #aa004f;\n$color7: #bebebe;\n$color8: #d6d6d6;\n$color9: #f8f7f7;\n$color10: #202121;\n$color11: #848484;\n$color12: #aa004f;\n$color13: #37AA1E;\n$color14: #E4E5F1;\n$color15: #CB186B;\n$color16: #FCD3CA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
